package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import com.composables.icons.lucide.ChevronLeft
import com.composables.icons.lucide.ChevronRight
import com.composables.icons.lucide.Lucide
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.pagination_next
import portalvv.shared.generated.resources.pagination_previous

@Composable
fun AppPagination(
    page: Int,
    pageCount: Int,
    onPageChange: (Int) -> Unit,
    modifier: Modifier = Modifier,
) {
    if (pageCount <= 1) return
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4),
    ) {
        IconButton(onClick = { onPageChange(page - 1) }, enabled = page > 0) {
            Icon(Lucide.ChevronLeft, contentDescription = stringResource(Res.string.pagination_previous))
        }
        pageItems(pageCount, page).forEach { item ->
            if (item == null) {
                Text(
                    text = "…",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.size(36.dp),
                )
            } else {
                val selected = item == page
                Surface(
                    onClick = { onPageChange(item) },
                    shape = AppShapes.small,
                    color = if (selected) MaterialTheme.colorScheme.primaryContainer else Color.Transparent,
                    contentColor =
                        if (selected) {
                            MaterialTheme.colorScheme.onPrimaryContainer
                        } else {
                            MaterialTheme.colorScheme.onSurface
                        },
                ) {
                    Box(
                        modifier = Modifier.size(36.dp),
                        contentAlignment = Alignment.Center,
                    ) {
                        Text(text = "${item + 1}", style = MaterialTheme.typography.bodyMedium)
                    }
                }
            }
        }
        IconButton(onClick = { onPageChange(page + 1) }, enabled = page < pageCount - 1) {
            Icon(Lucide.ChevronRight, contentDescription = stringResource(Res.string.pagination_next))
        }
    }
}

private fun pageItems(
    pageCount: Int,
    current: Int,
): List<Int?> {
    if (pageCount <= 7) return (0 until pageCount).toList()
    val items = mutableListOf<Int?>()
    items += 0
    val start = maxOf(1, current - 1)
    val end = minOf(pageCount - 2, current + 1)
    if (start > 1) items += null
    for (page in start..end) items += page
    if (end < pageCount - 2) items += null
    items += pageCount - 1
    return items
}
